import { buildPremiumPairValues, buildPremiumRows } from "../utils/premiumDisplay";

export default function PremiumPairValue({
  direction,
  phase = "entry",
  primaryPremium,
  buyPremium,
  sellPremium,
  className = "",
  fallback = "—",
  showEmptyRows = true,
}) {
  const pairValues = buildPremiumPairValues({
    direction,
    phase,
    primaryPremium,
    buyPremium,
    sellPremium,
  });
  const rows = buildPremiumRows({
    direction,
    phase,
    buyPremium: pairValues.buyPremium,
    sellPremium: pairValues.sellPremium,
    fallback,
    showEmptyRows,
  });
  const classNames = ["premium-pair-value", className].filter(Boolean).join(" ");
  const ariaLabel = rows.map((row) => `${row.label} ${row.value}`).join(", ");

  return (
    <span className={classNames} aria-label={ariaLabel}>
      {rows.map((row) => (
        <span
          key={row.side}
          className={`premium-pair-row${row.primary ? " premium-pair-row-primary" : " premium-pair-row-muted"}${row.hasValue ? "" : " premium-pair-row-empty"}`}
        >
          <span className="premium-pair-label">{row.label}</span>
          <span className="premium-pair-number">{row.value}</span>
        </span>
      ))}
    </span>
  );
}
